
// src/assets/data/forbiddenSongs.js

// 抖音禁止歌曲列表（按拼音首字母分组，中文按拼音排序，英文按字母表排序）
export const groupedForbiddenSongs = {
  "A": [
    "艾琳娜",
    "爱",
    "爱到",
    "爱到疯癫",
    "爱的供养",
    "爱的解脱",
    "爱的王道",
    "爱就对了",
    "爱来过",
    "爱你",
    "爱你没错",
    "爱你伤过醉过",
    "爱上你不如爱上海",
    "爱上你等于爱上了错",
    "爱情",
    "爱情风暴",
    "爱情的海洋",
    "爱情的背影",
    "爱情树",
    "爱与恨",
    "爱与愿违",
    "爱着爱着就永远",
    "安静了",
    "安全感",
    "暗恋",
    "岸上",
    "A Sea of Snow",
    "Always On My Mind",
    "Angel",
    "Asuka and you",
    "Authority"
  ],
  "B": [
    "八年的爱",
    "把你写在歌里",
    "白昼之月",
    "百鬼夜行",
    "拜你所赐",
    "背叛情歌",
    "背着风流泪",
    "被忘录",
    "奔跑的蜗牛",
    "逼",
    "比寂寞更寂寞",
    "比你贱",
    "彼岸花",
    "彼此",
    "别离开好吗",
    "别来爱我",
    "别来无恙",
    "别问我过得好不好",
    "别再说分手",
    "不说再见",
    "不完美心跳",
    "不为谁而作的歌",
    "不问",
    "不想做朋友",
    "不像情歌",
    "不小心",
    "不知",
    "不知不觉",
    "不完整的存在",
    "不要在",
    "不要再",
    "不要再来伤害我",
    "不怨",
    "不在场",
    "不负",
    "不负人间",
    "不夜城2001版",
    "不就是落单",
    "不死心还在",
    "不死之谜",
    "不想",
    "不一定",
    "Blame You",
    "Boom",
    "Bright",
    "Beauty Up My Life"
  ],
  "C": [
    "彩虹",
    "曹操",
    "曾经的你",
    "曾经太年轻",
    "差不多姑娘",
    "差不多先生",
    "成都",
    "成全",
    "城里的月光",
    "橙红年代",
    "承诺",
    "宠儿",
    "崇拜你",
    "出神入化",
    "触电",
    "辞君一别",
    "匆匆那年",
    "催眠术",
    "错过",
    "错位时空",
    "CAP GIRL"
  ],
  "D": [
    "答应我，别想我",
    "达尔文",
    "打",
    "大",
    "大城小爱",
    "大女人主义",
    "大女孩",
    "大天蓬",
    "大丈夫男子汉",
    "带你去",
    "带你走",
    "但丁",
    "弹",
    "当",
    "当爱来敲门",
    "当你",
    "当你老了",
    "当归",
    "挡不住的太阳",
    "刀马旦",
    "倒带",
    "到不了",
    "道两旁",
    "得",
    "等你",
    "等温相拥",
    "滴滴",
    "第一",
    "第三人称",
    "电话",
    "店小二",
    "丁达尔的梦",
    "动物森林",
    "斗牛士之歌",
    "斗牛要不要",
    "独活",
    "独路",
    "独善其身",
    "读不懂你的忧伤",
    "多余",
    "多余的我",
    "多喜欢你",
    "Dance KK",
    "Dear Tank",
    "DNTQ",
    "DROOL"
  ],
  "E": [
    "恶作剧",
    "二月",
    "Easy Come Easy Go"
  ],
  "F": [
    "发",
    "发光",
    "法",
    "帆",
    "繁",
    "反",
    "反正",
    "放不下",
    "放下的时候",
    "飞",
    "飞鸟和蝉",
    "飞鸟",
    "飞云",
    "非你莫属",
    "非酋",
    "沸",
    "费",
    "分",
    "分开",
    "分手",
    "风景旧曾谙",
    "风车",
    "风的",
    "风花",
    "风浪",
    "风起",
    "风之诺言",
    "风中芭蕾",
    "佛说",
    "敷衍",
    "浮",
    "浮夸",
    "浮生",
    "浮生未歇",
    "福",
    "父",
    "父亲",
    "负",
    "负重",
    "Feel Me",
    "Forever"
  ],
  "G": [
    "改变",
    "干杯",
    "感谢",
    "感觉",
    "感冒",
    "感情",
    "刚好",
    "该",
    "改",
    "盖",
    "尴尬",
    "赶",
    "敢",
    "感觉",
    "感谢你",
    "橄榄树",
    "港湾",
    "高原",
    "歌",
    "歌唱",
    "鸽子",
    "隔壁",
    "给",
    "给小孩",
    "给妈妈的信",
    "给我多一点",
    "给我你的爱",
    "跟",
    "跟我",
    "跟我走",
    "跟着",
    "更",
    "更好",
    "更加",
    "刚好遇见你",
    "故事",
    "故事1983",
    "故意",
    "关注者",
    "光",
    "光顾",
    "光影和你",
    "光年",
    "光年之外",
    "归",
    "归零歌",
    "归宿",
    "孤单",
    "孤单摩天轮",
    "孤独",
    "孤勇者",
    "古灵精怪",
    "谷",
    "鼓",
    "故",
    "故乡",
    "故意",
    "关于",
    "关于兰州",
    "关注",
    "光",
    "Gimme",
    "Goodbye my love",
    "Got It 3",
    "Got It 5"
  ],
  "H": [
    "海",
    "海阔天空",
    "海与天",
    "海芋恋",
    "汉之云",
    "浩瀚",
    "好好的",
    "好聚不好散",
    "好脾气",
    "好情",
    "好人",
    "好日子",
    "好想变苹果",
    "好想对他说",
    "好想听你说",
    "好心情",
    "好运来",
    "好",
    "好久不见",
    "好了",
    "好吗",
    "好像",
    "荷花",
    "荷塘月色",
    "鹤",
    "黑",
    "黑马",
    "黑暗里",
    "很",
    "很多",
    "很快",
    "很爱",
    "很安静",
    "很想你",
    "狠",
    "恨",
    "红",
    "红豆",
    "红玫瑰",
    "红昭愿",
    "红尘来去梦一场",
    "后来",
    "后来才知道",
    "后来后来",
    "换季",
    "换日线",
    "换我陪你",
    "黄昏恋人",
    "黄昏晓",
    "回到",
    "回归K-PAX星球",
    "回忆",
    "会不会",
    "会吗",
    "会有",
    "活着",
    "活该",
    "火",
    "火花",
    "火焰",
    "火车",
    "或者",
    "或许",
    "害怕",
    "好久",
    "Hope Ascendant",
    "heavy fog"
  ],
  "I": [
    "I see the Lights",
    "I.O.I.O",
    "I've Never Been To Me",
    "I can't love"
  ],
  "J": [
    "记得",
    "记得要忘记",
    "纪念日",
    "纪念品",
    "记恨",
    "寂寞才说爱",
    "寂寞暴走",
    "寂寞光年",
    "寂寞在唱歌",
    "嘉宾",
    "家",
    "家乡",
    "假",
    "假装",
    "假装我们没爱过",
    "假如",
    "假如爱有天意",
    "嫁",
    "嫁给我",
    "剑心",
    "剑魂",
    "健康",
    "见或不见",
    "见外",
    "江南",
    "江",
    "江湖",
    "江山",
    "将爱",
    "讲故事",
    "降温",
    "骄傲",
    "骄傲与渺小",
    "叫做",
    "接着",
    "街",
    "街头霸王",
    "结发",
    "解脱",
    "解忧",
    "借口",
    "戒烟",
    "借你一点泪",
    "今天",
    "金",
    "金钟罩铁布衫",
    "金色的口弦",
    "仅",
    "尽头",
    "近",
    "近在",
    "经过",
    "惊",
    "惊喜",
    "鲸",
    "井",
    "静",
    "静静",
    "镜",
    "镜子",
    "九",
    "九月九的酒",
    "九九女儿红",
    "久",
    "就是",
    "就是爱你",
    "旧",
    "旧梦情未了",
    "旧时光",
    "旧友",
    "救",
    "救命",
    "就当你没爱过",
    "几乎",
    "记忆",
    "Joseph"
  ],
  "K": [
    "开始懂了",
    "看见什么吃什么",
    "看透",
    "可爱万岁",
    "可可爱爱",
    "可惜",
    "可惜没如果",
    "可是",
    "可乐",
    "可能",
    "可能你还爱我",
    "可以",
    "刻",
    "刻画",
    "刻意",
    "空白",
    "空白格",
    "空",
    "空气",
    "空想",
    "控制",
    "口袋的温度",
    "口",
    "口红",
    "哭泣",
    "苦",
    "苦茶",
    "苦情",
    "苦行",
    "跨",
    "快",
    "快乐",
    "快乐女孩",
    "快乐至上",
    "快让我",
    "快说",
    "快雪",
    "快要",
    "盔甲",
    "窥探",
    "Kill Bill"
  ],
  "L": [
    "来不来都等你",
    "来不及",
    "来不及说",
    "来迟",
    "来到",
    "来都",
    "来来",
    "来生",
    "来时",
    "来世",
    "来听",
    "来我",
    "来者",
    "兰",
    "兰州",
    "蓝",
    "蓝天",
    "蓝天白云",
    "懒",
    "烂",
    "滥",
    "郎",
    "浪",
    "浪漫",
    "浪漫手机",
    "浪漫血液",
    "浪费",
    "浪子",
    "老",
    "老爸说",
    "老婆",
    "老了",
    "老人",
    "老师",
    "老男孩",
    "老实",
    "乐园",
    "泪",
    "泪奔",
    "泪桥",
    "泪塔",
    "类",
    "累",
    "冷",
    "冷风",
    "冷静",
    "离",
    "离开",
    "离开地球表面",
    "离人殇",
    "离别",
    "理想",
    "理由",
    "礼物",
    "李",
    "里",
    "理解",
    "恋爱",
    "恋爱元气弹",
    "恋人",
    "恋人未满",
    "凉凉",
    "凉凉夜色",
    "两",
    "两人行",
    "两难",
    "亮了",
    "了不起",
    "了解",
    "列车",
    "烈酒",
    "裂",
    "裂痕",
    "邻居",
    "林",
    "淋",
    "淋雨怎能不湿身",
    "零",
    "领",
    "另一个自己",
    "流浪",
    "流浪记",
    "流星",
    "留",
    "留下来",
    "六月的雨",
    "六十",
    "龙",
    "笼",
    "路",
    "路太",
    "路远",
    "路人",
    "路人甲",
    "旅程",
    "旅途",
    "旅行",
    "旅游",
    "绿",
    "绿罗裙",
    "绿洲",
    "乱",
    "伦敦大桥垮下来",
    "Lifestyle",
    "Life style2",
    "Love！",
    "LOST"
  ],
  "M": [
    "妈妈",
    "麻",
    "马",
    "马路",
    "骂",
    "骂醒",
    "吗",
    "买",
    "买买买",
    "满",
    "慢慢",
    "慢慢来",
    "慢慢喜欢你",
    "慢一点",
    "慢舞",
    "忙",
    "盲目",
    "猫",
    "毛",
    "矛盾",
    "冒险",
    "冒险家",
    "玫瑰",
    "玫瑰花",
    "美丽",
    "美丽的神话",
    "美丽新世界",
    "魅力",
    "妹妹",
    "门",
    "门外",
    "萌芽",
    "梦",
    "梦回花事了",
    "梦一场",
    "梦想",
    "梦醒",
    "梦醒时分",
    "梦游",
    "弥补",
    "迷",
    "迷宫",
    "迷路",
    "迷茫",
    "迷汤",
    "谜",
    "米",
    "米饭",
    "蜜",
    "蜜蜂",
    "免费",
    "秒",
    "渺小",
    "妙",
    "庙",
    "民国",
    "民航",
    "民谣",
    "名",
    "名字",
    "明天",
    "明明白白",
    "明明",
    "明日",
    "明日香",
    "明天的明天的明天",
    "明显的",
    "命",
    "命运",
    "命运的思量",
    "命中",
    "摸",
    "模仿",
    "模糊",
    "模样",
    "魔鬼中的天使",
    "魔鬼无罪",
    "魔法",
    "魔力",
    "陌生人",
    "默默",
    "末日",
    "末日之恋",
    "莫忘初衷",
    "漠",
    "漠河",
    "漠河舞厅",
    "某",
    "某人",
    "母亲",
    "木",
    "木偶戏",
    "目标",
    "目送",
    "牧马城市",
    "My Love",
    "My Sunshine",
    "My Way",
    "Mr.Perfect"
  ],
  "N": [
    "那",
    "那女孩对我说",
    "那时候",
    "那时候的树",
    "那些",
    "那些年",
    "那些你很冒险的梦",
    "那样",
    "那首歌",
    "那栋楼",
    "那你",
    "那一年",
    "那又",
    "南风知我意",
    "南下北上",
    "南山南",
    "难",
    "难忘",
    "难生恨",
    "你",
    "你被写在我的歌里",
    "你不再属于我",
    "你是我爱的人",
    "你是我的眼",
    "你是我的影子",
    "你怕不怕",
    "你还好不好",
    "你说会陪着我",
    "你说的",
    "你说他",
    "你太诚实",
    "你太猖狂",
    "你快乐未必我快乐",
    "你要离开一些时候",
    "你终于等到她",
    "你最好爱他",
    "逆风",
    "逆向行驶",
    "年纪",
    "年轮",
    "年少",
    "念",
    "念念",
    "念念有词",
    "鸟",
    "鸟语",
    "牛",
    "牛奶",
    "牛肉",
    "扭",
    "纽",
    "纽约",
    "农村",
    "农场",
    "农夫",
    "浓",
    "浓缩",
    "浓缩蓝鲸",
    "女",
    "女孩",
    "女孩当自强",
    "女人",
    "女生",
    "女神",
    "暖",
    "暖人",
    "暖暖的家",
    "No One Knows",
    "No Surprises",
    "Nothing Ever Changes"
  ],
  "O": [
    "Old Boy",
    "Only Lonely",
    "Off, Do Not Disturb"
  ],
  "P": [
    "拍",
    "拍写",
    "怕",
    "怕什么",
    "朋友",
    "碰",
    "碰巧",
    "皮",
    "皮肤",
    "疲惫",
    "偏爱",
    "偏心",
    "骗",
    "骗子",
    "飘",
    "飘散",
    "飘散的温馨",
    "拼命",
    "拼命三郎",
    "贫",
    "贫穷",
    "频率",
    "苹果",
    "萍",
    "萍聚",
    "平",
    "平衡",
    "平凡",
    "平凡之路",
    "平淡",
    "评分",
    "凭",
    "凭借",
    "婆",
    "婆婆",
    "泼水歌",
    "迫不及待",
    "破",
    "破晓",
    "破碎",
    "普通",
    "普通朋友",
    "Paper Heart Heist",
    "ParaDise",
    "Purse2"
  ],
  "Q": [
    "七",
    "七里香",
    "七秒",
    "期待",
    "期限",
    "其他",
    "其实",
    "其实很简单",
    "奇妙",
    "奇妙能力歌",
    "骑",
    "骑士",
    "起床",
    "起风了",
    "起初",
    "起初只是朋友",
    "气质",
    "汽车",
    "牵手",
    "千",
    "千百度",
    "千帆",
    "千万",
    "千禧",
    "签名",
    "前",
    "前方",
    "前进",
    "前路",
    "前世",
    "钱",
    "浅",
    "浅唱",
    "欠",
    "强",
    "墙",
    "蔷薇",
    "悄悄",
    "悄悄话",
    "敲",
    "敲打",
    "桥",
    "亲",
    "亲爱的",
    "亲爱的怪物",
    "亲爱的树洞",
    "亲爱",
    "亲口",
    "亲吻",
    "青春",
    "青春是",
    "青",
    "青花瓷",
    "青衣谣",
    "青云志",
    "轻",
    "轻狂",
    "清风作伴",
    "情",
    "情话",
    "情话微甜",
    "情人",
    "情书",
    "情歌",
    "晴天",
    "晴天与大海",
    "请",
    "请你",
    "请你给我好一点的情敌",
    "请说",
    "秋",
    "秋天",
    "求",
    "求助",
    "囚鸟",
    "去",
    "去爱你",
    "去北极",
    "去大理",
    "去流浪",
    "去远方",
    "全",
    "全部都",
    "全世界都停电",
    "全部",
    "劝",
    "缺点",
    "缺少",
    "却",
    "确定",
    "确认",
    "然后",
    "让",
    "让我爱",
    "让我爱她",
    "让我留在你身边",
    "热带雨林",
    "热",
    "热爱",
    "热情",
    "热血",
    "人",
    "人间",
    "人间一两风",
    "人间",
    "人来",
    "人生",
    "人生不易别委屈自己",
    "人生大好",
    "人生好似一幅画",
    "人世间",
    "人心",
    "任性",
    "认输",
    "认真",
    "扔",
    "仍然",
    "日",
    "日常",
    "日出",
    "日落",
    "日夜",
    "容易",
    "融",
    "融化",
    "融化了",
    "如果",
    "如果爱老了",
    "如果爱你自由这一次",
    "如果能够",
    "如果天还没黑",
    "如果我变成回忆",
    "如果天",
    "如果你",
    "如果你也听说",
    "如歌",
    "如何",
    "如愿",
    "如约",
    "软",
    "软弱",
    "蕊",
    "锐",
    "若",
    "若只如初见",
    "Runaway Mama",
    "Repeat I Love You",
    "River Flows in you",
    "ROSY7",
    "Reay killi",
    "Rosy7"
  ],
  "S": [
    "伞",
    "散",
    "散步",
    "丧",
    "撒娇",
    "傻",
    "傻子",
    "杀",
    "杀破狼",
    "杀死比尔",
    "杀手",
    "山",
    "山海",
    "山河",
    "山水",
    "伤",
    "伤心",
    "伤心换日线",
    "上",
    "上辈子",
    "上辈子的双胞胎",
    "上善若水",
    "上仙",
    "少",
    "少了一个人",
    "少年",
    "少年锦时",
    "少时",
    "少数",
    "奢",
    "奢侈",
    "舍不得",
    "舍",
    "设定",
    "身",
    "身边",
    "身不由己",
    "身体都知道",
    "深",
    "深情",
    "深情人 挫骨扬灰",
    "神",
    "神枪手",
    "神话",
    "神仙",
    "甚至",
    "生活",
    "生还者",
    "生命",
    "生如夏花",
    "生日",
    "声",
    "声音",
    "失去",
    "失重",
    "失恋",
    "失落",
    "失眠",
    "诗",
    "诗人",
    "狮子",
    "十字",
    "时间",
    "时间是个小偷",
    "时光",
    "时差",
    "时刻",
    "时尚",
    "实",
    "实在",
    "拾荒",
    "食",
    "食堂",
    "始终",
    "是",
    "是你",
    "是你想成为的大人吗",
    "是世界",
    "是妈妈是女儿",
    "誓言",
    "释然",
    "收",
    "收到",
    "收藏",
    "手",
    "手机",
    "手套",
    "守护",
    "守护星",
    "首",
    "首先",
    "受",
    "受伤",
    "受了点伤",
    "瘦",
    "书",
    "叔叔",
    "输",
    "输了你赢了世界又如何",
    "熟悉",
    "数",
    "数字",
    "树",
    "树林",
    "束缚",
    "刷",
    "刷牙",
    "帅",
    "帅哥",
    "双",
    "双人",
    "双子",
    "谁",
    "谁是对的人",
    "谁的青春不迷茫",
    "水",
    "水滴",
    "水滴狂响曲",
    "水果",
    "水手",
    "水星",
    "睡",
    "睡觉",
    "顺",
    "瞬间",
    "说",
    "说谎",
    "说书人",
    "说好了不见面",
    "说你爱我",
    "撕",
    "撕心",
    "思",
    "思念",
    "思慕",
    "私",
    "私奔",
    "死",
    "死心",
    "四",
    "四季",
    "四十",
    "四月",
    "松开",
    "送",
    "送给",
    "搜",
    "搜索",
    "苏",
    "苏格拉",
    "苏州河",
    "夙念",
    "素",
    "素颜",
    "速",
    "速度",
    "宿",
    "宿敌",
    "诉",
    "酸",
    "酸甜",
    "算",
    "算我活该",
    "虽然",
    "随便",
    "随你",
    "随它",
    "随时",
    "岁月",
    "孙",
    "孙子",
    "损",
    "损失",
    "所",
    "所有",
    "所以",
    "锁",
    "SEXY GIRL",
    "SHERO",
    "Super Star",
    "Super Model",
    "Syrup",
    "sigma"
  ],
  "T": [
    "他",
    "他不懂",
    "他就是他",
    "他还是不懂",
    "他一时兴起你不离不弃",
    "她",
    "她不爱",
    "她的",
    "她来",
    "她没",
    "她说",
    "她以为",
    "塔",
    "踏",
    "踏山河",
    "台",
    "台北沉睡了",
    "台风",
    "太",
    "太聪明",
    "太热",
    "太想",
    "太阳",
    "太阳终将会升起",
    "态度",
    "谈",
    "谈感情",
    "谈情",
    "坦白",
    "坦然",
    "叹气",
    "探世界",
    "探索",
    "逃",
    "逃跑",
    "逃避",
    "套",
    "特别",
    "特地",
    "特点",
    "特价",
    "特快乐",
    "特朗",
    "疼",
    "疼爱",
    "疼痛",
    "腾",
    "藤",
    "梯",
    "梯田",
    "提醒",
    "体",
    "体会",
    "体面",
    "替",
    "替我",
    "替我爱你",
    "天",
    "天赐",
    "天灰",
    "天将明",
    "天亮以后",
    "天亮了",
    "天平",
    "天气",
    "天上凉都",
    "天生",
    "天使",
    "天使在唱歌",
    "天梯",
    "天堂",
    "天天",
    "天外来物",
    "天下",
    "天下第一喜欢你",
    "天后",
    "天黑黑",
    "天真有邪",
    "天注定",
    "甜",
    "甜美",
    "甜蜜",
    "甜心",
    "条件",
    "跳舞",
    "听",
    "听说",
    "听说你",
    "听雪",
    "听雨",
    "听着",
    "童话",
    "童话幻灭",
    "童年",
    "童年老家",
    "痛",
    "痛苦",
    "痛快",
    "偷偷",
    "偷偷地",
    "头",
    "头发",
    "头脑",
    "透",
    "透明",
    "透支",
    "突然",
    "突如其来",
    "图",
    "图形",
    "途",
    "途中",
    "土",
    "土地",
    "兔子",
    "退",
    "褪色",
    "褪黑素",
    "脱",
    "脱下",
    "妥协",
    "To Hebe",
    "Too Much",
    "Titanic x 开门进行曲"
  ],
  "U": [
    "uniqueness"
  ],
  "V": [],
  "W": [
    "晚安",
    "晚风来",
    "晚婚",
    "万",
    "万般",
    "万般爱",
    "万般无奈",
    "万花",
    "万花筒",
    "万疆",
    "万劫",
    "万里",
    "万岁",
    "万幸",
    "万一",
    "万一奥特曼打不赢小怪兽",
    "万丈",
    "亡",
    "王",
    "王子",
    "网",
    "网络",
    "往",
    "往事",
    "忘记",
    "忘了我",
    "忘了她",
    "忘情",
    "忘情水",
    "忘忧",
    "望",
    "望不见少年郎",
    "为你",
    "为你打call",
    "为你存在",
    "为你成全",
    "为江山",
    "为一个人",
    "为什么",
    "为爱",
    "为爱痴",
    "为了",
    "未",
    "未来",
    "未完成的",
    "未知",
    "位置",
    "温",
    "温暖",
    "温柔的慈悲",
    "温柔",
    "温习",
    "文本",
    "文艺",
    "文艺少年",
    "我不是",
    "我不在乎",
    "我不配",
    "我亲爱的",
    "我还不习惯",
    "我好",
    "我好想你",
    "我恨",
    "我恨我",
    "我会",
    "我会等",
    "我就是我",
    "我就是这样",
    "我离开",
    "我离开了北方不再有眼泪",
    "我梦见你梦见我",
    "我能",
    "我亲爱的",
    "我算什么",
    "我是你的",
    "我是你的影子",
    "我听着",
    "我为你",
    "我忘了",
    "我问",
    "我无所谓",
    "我想要",
    "我想念",
    "我想我不会爱你",
    "我要",
    "我要的",
    "我要飞",
    "我要快乐",
    "我要我们",
    "我一直都在",
    "我以为",
    "我终于明白",
    "我有点",
    "我有一",
    "我在这里",
    "我知道",
    "我只要",
    "我做不到不想你",
    "卧底",
    "握",
    "握手",
    "呜",
    "呜呼",
    "污",
    "污点",
    "屋",
    "屋顶",
    "无",
    "无法代替",
    "无法喘息的痛",
    "无归期",
    "无泪",
    "无情",
    "无情的情书",
    "无人判我",
    "无事生非",
    "无数",
    "无数个",
    "无天",
    "无忘",
    "无畏",
    "无问",
    "无问西东",
    "无暇",
    "无效",
    "无休",
    "无药",
    "无用",
    "无怨",
    "无终",
    "无足",
    "五",
    "五月天",
    "五十年",
    "午餐",
    "午夜",
    "武",
    "武士",
    "武器",
    "误会",
    "勿忘",
    "勿忘你",
    "雾",
    "雾里",
    "雾中",
    "Wake",
    "Winning Game",
    "Watch Me Shine",
    "Woman In Love",
    "whiplash",
    "Watching the snow by the sea"
  ],
  "X": [
    "西",
    "西边",
    "西门",
    "西厢",
    "夕阳",
    "希望",
    "习惯",
    "习惯一个人",
    "洗",
    "洗澡",
    "喜欢",
    "喜欢你",
    "喜闻乐见",
    "细",
    "细水",
    "细节",
    "下",
    "下一站",
    "下一个我",
    "下雨",
    "下雨天",
    "夏",
    "夏雪",
    "夏雨诗",
    "夏天",
    "夏天的微笑",
    "夏夜",
    "仙",
    "仙女",
    "先",
    "先生",
    "闲",
    "闲人",
    "贤",
    "弦",
    "现",
    "现在",
    "现场",
    "陷入",
    "陷阱",
    "羡慕",
    "乡",
    "乡下",
    "香",
    "香烟散不尽人间苦",
    "想",
    "想唱",
    "想到",
    "想对你",
    "想对你说的",
    "想飞",
    "想过",
    "想家",
    "想念",
    "想让你",
    "想他",
    "想她",
    "想我",
    "想我了吗",
    "想我在",
    "想我想",
    "想要",
    "想要对你说",
    "想一个人",
    "想自由",
    "向",
    "向往",
    "像",
    "像风",
    "像风一样",
    "像你",
    "像女孩的女人",
    "像晴天像雨天",
    "像他",
    "像我",
    "像昨天",
    "逍遥",
    "逍遥叹",
    "消失",
    "消息",
    "小",
    "小白",
    "小城",
    "小城大事",
    "小丑",
    "小动物",
    "小哥哥",
    "小酒窝",
    "小暖",
    "小女人",
    "小倩",
    "小时候",
    "小时候的",
    "小时代",
    "小时光",
    "小手",
    "小暑",
    "小水",
    "小偷",
    "小幸运",
    "小夜曲",
    "小宇宙",
    "小雨",
    "小愿望",
    "小至",
    "小主人",
    "小子",
    "小模样",
    "小星星",
    "小小",
    "小小大人物",
    "小幸运",
    "小宇",
    "小遇见",
    "小指",
    "孝",
    "孝敬爹和妈",
    "笑",
    "笑容",
    "笑话",
    "谢谢",
    "谢谢爱",
    "谢谢你的温柔",
    "心",
    "心不由己",
    "心城",
    "心大",
    "心动",
    "心房",
    "心光",
    "心慌",
    "心火",
    "心结",
    "心口",
    "心口停雪",
    "心理",
    "心里",
    "心里有数",
    "心里话",
    "心灵",
    "心路",
    "心墙",
    "心情",
    "心事",
    "心酸",
    "心痛",
    "心痛的",
    "心头",
    "心弦",
    "心绪",
    "心意",
    "心有余",
    "心雨",
    "心愿",
    "心中",
    "新",
    "新宠",
    "新歌",
    "新欢",
    "新家",
    "新街",
    "新年",
    "新娘",
    "新窝",
    "新衣",
    "新雨后",
    "新愿",
    "心",
    "信",
    "信封",
    "信号",
    "信息",
    "信仰",
    "星星",
    "星星之火",
    "星星住进你眼睛",
    "星月",
    "星月糖",
    "星月为媒",
    "星河",
    "星空",
    "星球",
    "星晴",
    "星语",
    "星星",
    "醒",
    "醒来",
    "幸福",
    "幸福的两个人",
    "性",
    "性格",
    "姓名",
    "兄弟",
    "胸口",
    "雄",
    "熊",
    "熊猫",
    "休",
    "修",
    "修炼",
    "羞",
    "羞答答",
    "秀",
    "秀恩爱",
    "需要",
    "许",
    "许多",
    "许诺",
    "许愿",
    "叙",
    "叙述",
    "玄",
    "旋律",
    "选择",
    "学",
    "学不会",
    "学习",
    "雪",
    "雪花",
    "雪落",
    "雪落下的声音",
    "血",
    "血液",
    "寻",
    "寻找",
    "巡",
    "循环"
  ],
  "Y": [
    "压力",
    "压抑",
    "呀",
    "丫头",
    "鸭子",
    "烟花",
    "烟火",
    "烟雨",
    "烟雨小镇",
    "烟雨行",
    "烟雾",
    "延",
    "延长比赛",
    "沿途",
    "颜色",
    "眼",
    "眼泪",
    "眼泪笑了",
    "眼睛",
    "眼前",
    "演",
    "演唱",
    "演员",
    "厌",
    "厌倦",
    "艳",
    "艳阳",
    "燕",
    "燕儿飞",
    "燕子",
    "阳光",
    "阳光美眉",
    "阳光宅男",
    "阳关",
    "阳台上",
    "样子",
    "邀请",
    "摇摆",
    "摇滚",
    "摇头",
    "咬",
    "咬牙",
    "药",
    "要",
    "要抱抱",
    "要不起",
    "要唱歌",
    "要的",
    "要飞",
    "要快乐",
    "要你",
    "要死",
    "要我说",
    "要幸福",
    "要一起",
    "耶",
    "也",
    "也许",
    "也许有一天",
    "野",
    "野孩子",
    "野花",
    "野马",
    "野子",
    "夜",
    "夜半",
    "夜车",
    "夜风",
    "夜来香",
    "夜南京",
    "夜曲",
    "夜深",
    "夜太美",
    "夜行者",
    "夜夜",
    "一把",
    "一半",
    "一辈子",
    "一定",
    "一定要幸福",
    "一个",
    "一个今天胜过无数个明天",
    "一个人",
    "一个人就好",
    "一个人的流浪",
    "一个人也可以",
    "一花一剑",
    "一句话",
    "一刹那的烟火",
    "一整个爱住你",
    "一直",
    "一直一直爱",
    "一直很安静",
    "一些",
    "一些事",
    "一下",
    "一眼",
    "一夜",
    "一首",
    "一一",
    "一月",
    "一",
    "伊",
    "伊人",
    "医",
    "医院",
    "依",
    "依然",
    "依赖",
    "依靠",
    "衣柜",
    "仪式",
    "咦",
    "移动",
    "遗憾",
    "遗憾藏在心底",
    "遗失",
    "已",
    "以后",
    "以前",
    "以为",
    "倚",
    "义",
    "艺术",
    "忆",
    "异",
    "异地",
    "意外",
    "意思",
    "意志",
    "因为",
    "因为一个人",
    "阴天",
    "音乐",
    "音律",
    "银河",
    "银魂",
    "银奖",
    "银饰",
    "饮",
    "饮食",
    "瘾",
    "印",
    "印象",
    "英雄",
    "英雄有路",
    "樱花",
    "樱花树",
    "拥抱",
    "拥有",
    "永",
    "永不",
    "永恒",
    "永远",
    "永远都在",
    "用",
    "用力",
    "用情",
    "用情山水",
    "用喜欢的方式过好每一天",
    "忧",
    "忧愁",
    "幽",
    "幽默",
    "悠",
    "悠长",
    "尤",
    "尤其",
    "由",
    "由于",
    "邮",
    "邮票",
    "犹豫",
    "油",
    "油菜",
    "游",
    "游戏",
    "游泳",
    "有",
    "有的",
    "有点",
    "有毒",
    "有翡",
    "有风",
    "有故事",
    "有过",
    "有过很多的梦",
    "有你就",
    "有口",
    "有梦",
    "有你在",
    "有你陪",
    "有期",
    "有人",
    "有时",
    "有时候",
    "有谁",
    "有他",
    "有味",
    "有限",
    "有效",
    "有些",
    "有心",
    "有些",
    "有一",
    "有一天",
    "有意",
    "有用",
    "有缘",
    "有罪",
    "右",
    "右手",
    "又",
    "又要",
    "幼稚的口吻与成人的心",
    "余波荡漾",
    "鱼",
    "鱼缸",
    "鱼丸",
    "愉快",
    "愚",
    "愚人",
    "雨",
    "雨爱",
    "雨滴",
    "雨花",
    "雨霖铃",
    "雨念",
    "雨声",
    "雨水",
    "雨停",
    "雨夜",
    "雨夜的叹息",
    "雨中",
    "语",
    "语言",
    "玉",
    "玉兰",
    "玉米",
    "遇见",
    "遇见未来",
    "愈",
    "欲望",
    "冤枉",
    "元旦",
    "原谅",
    "原色",
    "原味",
    "原来",
    "原来你",
    "原野",
    "圆",
    "圆梦",
    "圆月",
    "缘分",
    "缘字书",
    "远",
    "远方",
    "远远",
    "远远在一起",
    "远行",
    "远走高飞",
    "愿",
    "愿我与你",
    "愿与愁",
    "愿望",
    "约",
    "约定",
    "月",
    "月光",
    "月光手札",
    "月亮",
    "月亮船",
    "月亮代表我的心",
    "月亮说",
    "月亮照山川",
    "月牙湾",
    "月圆",
    "岳飞",
    "越",
    "越来越",
    "越来越爱",
    "越远",
    "云",
    "云端相见",
    "云朵",
    "云海",
    "云间",
    "云里",
    "云烟",
    "云雨",
    "云中",
    "允",
    "允许",
    "运",
    "运动",
    "运气",
    "韵",
    "蕴",
    "Yes I Love You",
    "Yesterday's Echo"
  ],
  "Z": [
    "再见",
    "再见我的爱人",
    "再会吧！我的心上人",
    "再遇太难",
    "再约",
    "再重",
    "再重来",
    "再走",
    "在",
    "在等风",
    "在歌里",
    "在KTV过夜",
    "在梦里",
    "在那",
    "在那里",
    "在南方",
    "在人间",
    "在时间里",
    "在手上",
    "在水一方",
    "在我心里",
    "在我身边",
    "在我眼里",
    "在我这",
    "在不在",
    "早知道",
    "怎么办",
    "扎",
    "扎心",
    "摘",
    "摘星",
    "宅",
    "窄",
    "站",
    "站台",
    "战争",
    "张",
    "张三",
    "张先生",
    "长大",
    "长大以后",
    "长恨",
    "长街",
    "长久",
    "长路",
    "长情",
    "长生",
    "长相思",
    "长夜",
    "长椅",
    "掌握",
    "找回",
    "找幸福给你",
    "照",
    "照进",
    "照亮",
    "照片",
    "这",
    "这城市",
    "这个人已经与我无关",
    "这就是",
    "这就是爱",
    "这就是我",
    "这就是生活",
    "这世界",
    "这世界那么多人",
    "这故事太长",
    "这一刻",
    "这里",
    "这里没有天使",
    "这年",
    "这些年",
    "这样",
    "这也许",
    "这一",
    "这一次",
    "这一个人",
    "这一生",
    "这世界",
    "真",
    "真心",
    "真心话",
    "真相",
    "珍惜",
    "震",
    "震撼",
    "争",
    "争吵",
    "挣扎",
    "睁",
    "睁开",
    "蒸发",
    "整",
    "整体",
    "整天",
    "正",
    "正常",
    "正好",
    "正确",
    "正在",
    "证",
    "证据",
    "之",
    "之后",
    "之前",
    "之间",
    "之后",
    "之一",
    "知道",
    "知足",
    "执",
    "执迷",
    "执手看人间",
    "直",
    "直到",
    "直到永远",
    "直接",
    "直觉",
    "值",
    "值得",
    "只",
    "只对你有感觉",
    "只对你说",
    "只对你",
    "只看见你",
    "只可",
    "只要你",
    "只为你",
    "只想要",
    "只选择",
    "只愿你",
    "只愿和你相爱",
    "只在这里",
    "只想",
    "只想说声爱你",
    "只因为",
    "只有",
    "只有我",
    "只在乎",
    "只为了",
    "纸",
    "纸上",
    "指",
    "指纹",
    "指间",
    "志",
    "志愿",
    "至少",
    "至少还有我",
    "治愈",
    "致",
    "致青春",
    "致敬",
    "中毒",
    "中二",
    "中国",
    "中国话",
    "中年",
    "中心",
    "终于",
    "终于明白",
    "种",
    "种子",
    "仲",
    "仲夏",
    "众",
    "众多",
    "重",
    "重大",
    "重要",
    "重作一个梦",
    "周",
    "周末",
    "周年",
    "周期",
    "周围",
    "轴",
    "昼夜",
    "皱纹",
    "逐渐",
    "主动",
    "主观",
    "主要",
    "煮",
    "煮雨",
    "祝福",
    "著名",
    "注意",
    "祝你",
    "抓",
    "抓紧",
    "抓紧我放弃我",
    "专",
    "专属",
    "专属电影",
    "专属天使",
    "转",
    "转动",
    "转弯",
    "转身",
    "转世",
    "转眼",
    "妆",
    "装",
    "装作",
    "追",
    "追光",
    "追梦",
    "追寻",
    "追忆",
    "准备",
    "准时",
    "子",
    "子女",
    "仔",
    "仔细",
    "自",
    "自己",
    "自夸",
    "自然",
    "自我",
    "自由",
    "自娱",
    "自愿",
    "自在",
    "走路",
    "走钢索的人",
    "走马",
    "走散",
    "走失",
    "走心",
    "走远",
    "奏",
    "揍",
    "租",
    "租客",
    "足够",
    "足矣",
    "族",
    "祖国",
    "最",
    "最后",
    "最后一面",
    "最后一眼",
    "最久的瞬间",
    "最可爱",
    "最美",
    "最美好的",
    "最深的",
    "最熟悉",
    "最晚",
    "最爱",
    "最爱的人",
    "最长的",
    "最好的",
    "最近",
    "最近还好吗",
    "最怕",
    "最疼",
    "最想",
    "最需要",
    "最重要",
    "最终",
    "醉",
    "醉千年",
    "醉拳",
    "醉清风",
    "醉人",
    "昨日",
    "昨天",
    "左右",
    "作",
    "作家",
    "作梦",
    "作曲",
    "作为",
    "作弊",
    "做",
    "做不到",
    "做得到",
    "做你的",
    "做朋友",
    "做梦",
    "做自己",
    "2月30号见",
    "612星球",
    "4号病房"
  ]
};

// 导出所有歌曲的扁平列表（用于搜索）
export const forbiddenSongsList = (() => {
  const allSongs = [];
  for (const letter in groupedForbiddenSongs) {
    allSongs.push(...groupedForbiddenSongs[letter]);
  }
  return allSongs;
})();